import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { TRANSPARENT } from '../../tornado/utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  return {
    alpha: 0,
    rect: true,
    color: TRANSPARENT,
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Image: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
    },
  };
};
